import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegistrationComponent } from './registration/registration.component';
import { ProgramComponent } from './program/program.component';
import { HomeComponent } from "src/app/home/home.component";
import { ConfirmationComponent } from "src/app/confirmation/confirmation.component";
import { AdminComponent } from "src/app/admin/admin.component";
import { AuthGuard } from 'src/app/auth/auth-guard.service';
import { LoginComponent } from 'src/app/auth/login.component';
import { ErrorComponent } from 'src/app/error/error.component';
import { LandingComponent } from './main/landing.component';
import { CreateRequestGuardService } from 'src/app/services/navigation-gaurd.service';


const ROUTES: Routes = [
    { path: '', redirectTo: '/app-home', pathMatch: 'full' },
    { path: 'app-home', component: HomeComponent,  canDeactivate: [CreateRequestGuardService] },
    { path: 'app-home/:section', component: HomeComponent, canDeactivate: [CreateRequestGuardService] },
    { path: 'app-registration', component: RegistrationComponent, canDeactivate: [CreateRequestGuardService] },
    { path: 'app-program', component: ProgramComponent, canDeactivate: [CreateRequestGuardService] },
    { path: 'app-confirmation', component: ConfirmationComponent, canDeactivate: [CreateRequestGuardService] },
    { path: 'login', component: LoginComponent },
    { path: 'login/:url', component: LoginComponent },
    // { path: 'app-adminlanding', component: AdminLandingComponent,  canActivate: [AuthGuard] },
    { path: 'error', component: ErrorComponent },
    { path: 'app-admin', component: AdminComponent ,  canDeactivate: [CreateRequestGuardService],  canActivate: [AuthGuard]},
    { path: 'app-landing', component: LandingComponent,  canDeactivate: [CreateRequestGuardService],  canActivate: [AuthGuard]},
    { path: 'app-registration/:organizationguid', component: RegistrationComponent ,  canDeactivate: [CreateRequestGuardService],  canActivate: [AuthGuard]},
    { path: '**', redirectTo: '' }
];

@NgModule({
  exports: [
    RouterModule
  ],

  imports: [
    RouterModule.forRoot(ROUTES)
  ],

  providers: [  ]
})

/** A module to handle the applications root routing. */
export class AppRoutingModule { }
